/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Empty, Pagination, Table } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import useCustomApiRequest from '../../custom-hooks/useCustomApiRequest';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

const SharedAntdTable = ({
  scroll,
  className,
  hasPagination,
  tableDataSource,
  tableColumns,
  allFetchedTableData,
  setFormModalOpened,
  setDetailsModalOpened,
  setConfirmModal,
  setFetchTableDataCount,
  isLoadingTableData,
  setIsLoadingTableData,
  setSelectedTableRow,
  user,
  //
  tablePagination,
  baseTablePageUrl,
  showHeader = true,
  ...props
}) => {
  const navigate = useNavigate();
  const customApiRequest = useCustomApiRequest();
  const { i18n, t } = useTranslation();
  return (
    <>
      <Table
        scroll={{
          x: scroll || 1500
        }}
        rowSelection={props?.rowSelection || null}
        showHeader={showHeader}
        locale={{
          emptyText: (
            <Empty description={false}>
              {props?.emptyText || t('employeesTable.empty')}
            </Empty>
          )
        }}
        pagination={false}
        className={`antd-custom-table ${className}`}
        dataSource={tableDataSource}
        columns={useMemo(
          () =>
            tableColumns({
              allFetchedTableData,
              setFormModalOpened,
              setDetailsModalOpened,
              setConfirmModal,
              setFetchTableDataCount,
              setSelectedTableRow,
              setIsLoadingTableData,
              token: user?.token,
              customApiRequest,
              i18n,
              t,
              ...props
            }),
          [allFetchedTableData]
        )}
        footer={false}
      />

      {hasPagination && tablePagination?.total > 0 && (
        <Pagination
          style={{
            marginTop: 18
          }}
          locale={{
            jump_to: i18n?.language === 'ar' ? 'إذهب إلى' : 'Go to',
            // page: i18n?.language === 'ar' ? 'الصفحة' : 'Page'
            page: ''
          }}
          showSizeChanger={false}
          defaultCurrent={1}
          current={tablePagination?.current_page}
          pageSize={tablePagination?.per_page}
          total={tablePagination?.total}
          // itemRender={itemRender}
          onChange={(page, pageSize) => {
            // setFetchTableDataCount((prev) => prev + 1);
            navigate(`${baseTablePageUrl}&page=${page}`);
          }}
          hideOnSinglePage={true}
        />
      )}
    </>
  );
};

export default SharedAntdTable;
